class Title {
  constructor () {
    this.title()
  }

  title () {
    const testTitle = document.title.slice(2)
    if (document.title) {
      document.title = testTitle
    }
  }
}

export default Title
